var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.83325H3.33333C2.59695 7.83325 2 8.43021 2 9.16659V13.8333C2 14.5696 2.59695 15.1666 3.33333 15.1666H12.6667C13.403 15.1666 14 14.5696 14 13.8333V9.16659C14 8.43021 13.403 7.83325 12.6667 7.83325Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 7.83325V5.16659C4.6665 4.28253 5.01769 3.43468 5.64281 2.80956C6.26794 2.18444 7.11578 1.83325 7.99984 1.83325C8.88389 1.83325 9.73174 2.18444 10.3569 2.80956C10.982 3.43468 11.3332 4.28253 11.3332 5.16659V7.83325",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/lock.be14d97b.svg";
export { ForwardRef as ReactComponent };